var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Catch errors from a promise and return them as an array or the result
 * @param promise A promise to catch errors from
 * @param errorsToCatch An array of error classes to catch. If not provided, all errors will be caught.
 * @returns The promise result or an array with the error
 */
export function catchError(promise, errorsToCatch) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = yield promise;
            return [undefined, data];
        }
        catch (error) {
            if (errorsToCatch === undefined) {
                return [error];
            }
            if (errorsToCatch.some((e) => error instanceof e)) {
                return [error];
            }
            throw error;
        }
    });
}
//# sourceMappingURL=catchError.js.map